import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { responseArray } from '../nest-model/nest-model';

@Injectable()
export class GamificationApiProvider {

  private _service: string = 'attendance';
  private _model: string = 'gamification';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getAchievement(empId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'achievement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);

    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getFavAchievement(empId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'achievementFavorite';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getDetailAchievement(badgeId: number): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'detailAchievementEmployee';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof badgeId !== 'undefined' && badgeId !== null) _urlParams.badgeId = badgeId;


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public updateFavAchievement(badgeId: number): Observable<any> {
    const _method: string = 'PUT';
    const _func: string = 'updateFavorite';
    const _params: any = {
      badgeId,
    };
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getProfileAchievement(empId: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'achievementInProfile';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);

    console.log(_url, ' ngapa nih')
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  /**
   * @param {object}
   * module : string
   * AttendanceOvertime: string
   * AttendanceIn: string
   * TaskTraveler: string
   */
  cekAchievement(formData: Object) {
    const method: string = "POST";
    const model: string = this._model;
    const func: string = "cekAchievement";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._service);
    return this.nestApiProvider.request<responseArray<any>>(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gamification/gamification-api.ts